export class Triple<T, R, K> {

    constructor(
        public x: T,
        public y: R,
        public z: K,
    ) { }
}
